import React, { useState, useCallback, useEffect } from 'react';
import { useThrottleFn } from 'ahooks';

export const Textarea = React.memo((props) => {
  const { title, name, value, placeholder, onChange } = props;
  const [innerValue, setInnerValue] = useState(value);
  const onChangeThrottled = useThrottleFn(onChange, { wait: 300 });

  const handleChange = useCallback(
    (e) => {
      setInnerValue(e.target.value);
      onChangeThrottled.run(e.target.value, name);
    },
    [onChangeThrottled, name],
  );

  useEffect(() => {
    setInnerValue(value);
  }, [value]);

  return (
    <div className="leading-0">
      <div className="mb-1">
        <span className="text-xs text-[#7f7f7f] leading-[14px]">{title}</span>
      </div>
      <textarea
        value={innerValue}
        onChange={handleChange}
        placeholder={placeholder || `请输入${title}`}
        className="w-full h-[100px] min-h-[60px] max-h-[300px] p-3 text-xs leading-[14px] text-[#2d2d2d] bg-[#f9fbfb] border border-[#eee] rounded focus:border-primary resize-none"
      />
    </div>
  );
});

export const TextareaView = React.memo(({ title, value }) => {
  return (
    <div className="px-4 py-2.5 border-b border-[#efefef]">
      <div className="flex items-center justify-between h-5">
        <span className="text-[#2D2D2D] text-xs font-semibold">{title}</span>
      </div>
      <p className="tiny-scrollbar break-words whitespace-pre-wrap overflow-auto tiny-scrollbar max-h-[120px] -mx-2 px-2 py-1 rounded-sm text-xs text-[#2d2d2d]">
        {value}
      </p>
    </div>
  );
});
